import { useContext, useEffect, useState } from "react";
import BrandLogo from "../../assets/img/BrandLogo.png";
import { NavLink } from "react-router-dom";
import { persistor, store } from "../../redux/configStore";
import { neutral, surface } from "../../theme/tokens";
import { settings } from "../../utils/config";
import {
  Avatar,
  Button,
  Drawer,
  Dropdown,
  Flex,
  Popconfirm,
  Typography,
  message,
} from "antd";
import {
  BulbFilled,
  BulbOutlined,
  LogoutOutlined,
  MenuOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { getInfoUser } from "../../api/User/infoUser";
import { clearSwrCache } from "../../utils/swrCache";
import { useSelector } from "react-redux";

import { ThemeContext } from '../../contexts/ThemeContext';
export default function HeaderConek() {
  const { user } = useSelector(
    (state) => state.persistedReducer.user
  );

  const [open, setOpen] = useState(false);
  const [openHeader, setOpenHeader] = useState(false);

  const { isDarkMode, toggleTheme } = useContext(ThemeContext);

  const showDrawer = () => {
    setOpenHeader(true);
  };
  const onClose = () => {
    setOpenHeader(false);
  };
  const handleOpenChange = (flag) => {
    setOpen(flag);
  };
  useEffect(() => {
    const fetchData = async () => {
      await store.dispatch(getInfoUser());

    };
    fetchData();
  }, []);

  const logOut = async () => {
    try {
      // await store.dispatch(logoutUser());
      persistor.pause();
      persistor.flush().then(() => {
        clearSwrCache();
        settings.delete_cookie("access_token");
        settings.delete_cookie("type_user");
        window.location.assign("/login");
        return persistor.purge();
      });
    } catch (error) {
      message.error(error);
    }
  };

  const { Text } = Typography;
  const items = [
    {
      key: "1",
      label: (
        <Button
          type="primary"
          icon={<LogoutOutlined />}
          onClick={logOut}
          danger
        >
          Đăng xuất
        </Button>
      ),
    },
  ].filter(Boolean); // lọc bỏ null/false


  return (
    <>
      <Flex gap="middle" align="center" justify="center">
        <NavLink to={"/"} style={{ display: "flex" }}>
          <img style={{ width: "117px" }} src={BrandLogo} alt="logo" />
        </NavLink>
      </Flex>
      <Button type="text" onClick={showDrawer} className="menu-button">
        <MenuOutlined style={{ fontSize: 20 }} />
      </Button>
      {/* Responsive */}
      <Drawer
        title="Thông tin người dùng"
        placement="left"
        onClose={onClose}
        open={openHeader}
      >
        <Flex justify="flex-start" gap={"middle"} vertical>
          <Flex align="center" justify="space-between" gap={10}>
            <Avatar
              style={{ cursor: "pointer" }}
              size={40}
              src=""
              icon={<UserOutlined />}
            />
            <p style={{ color: neutral[900] }}>

              <NavLink style={{ color: "var(--op-brand)" }} to={"editUser"}>
                NGUYEN VAN A
              </NavLink>
            </p>

          </Flex>

          <Flex align="flex-start" gap={10} justify="center" vertical>
            <p>Email: 1111</p>
            <p>Số điện thoại: aaa</p>
            <Popconfirm
              title="Bạn có chắc chắn muốn đăng xuất?"
              onConfirm={logOut}
              okText="Đồng ý"
              cancelText="Hủy"
            >
              <Button type="primary" icon={<LogoutOutlined />} danger>
                Đăng xuất{" "}
              </Button>
            </Popconfirm>
          </Flex>
        </Flex>
      </Drawer>
      {/* End */}

      <Flex
        className="header-content"
        gap={"middle"}
        align="center"
        justify="space-between"
      >
        <Flex
          align="center"
          justify="space-between"
          gap={"middle"}
          className="header_right"
        >
          {/* Theme Toggle Button */}
          <Button
            type="text"
            icon={isDarkMode ? <BulbFilled /> : <BulbOutlined />}
            onClick={toggleTheme}
            style={{
              color: isDarkMode ? surface.onDark : neutral[900],
              marginRight: '10px'
            }}
          />


          <Typography.Text style={{ color: neutral[900] }}>

            <NavLink style={{ color: "var(--op-brand)" }} to={"/account-setting"}>
              {user?.data?.username ?? user?.data?.email}
            </NavLink>

          </Typography.Text>
          <Flex align="center" justify="space-between">

            {user?.data && (
              <>
                <Dropdown
                  menu={{
                    items,
                  }}
                  trigger={["click"]}
                  onOpenChange={handleOpenChange}
                  open={open}
                >
                  <div style={{ lineHeight: "20px", marginRight: "10px" }}>
                    <Avatar
                      style={{ cursor: "pointer" }}
                      size={40}
                      icon={user?.data?.avatar ? null : <UserOutlined />}
                      // src={userAvatar}
                    />
                  </div>
                </Dropdown>
              </>
            )}
          </Flex>
        </Flex>
      </Flex>
    </>
  );
}
